import React from "react";
import "./vision.css";
import mission from "../../../assets/images/targeting (6).png";
import vision from "../../../assets/images/vision.png";
import values from "../../../assets/images/values.png";

const Vision = () => {
  return (
    <>
      <section className="vision">
        <h2 className="mt-3">Our Vision, Mission and Values</h2>
        <div className="container">
          <div className="row">
            <div className="col-md-4 d-flex">
              <div className="viscard">
                <div className="vision-content">
                  <div className="vision-title">
                    <p>
                      Our <span style={{ color: "#d2a98e" }}>Vision</span>
                    </p>
                  </div>
                  <div className="vision-desc">
                    <p>
                      We believe that having a cohesive group and succeeding
                      with the effective solution are both facilitated by having
                      diverse perspectives that generate creative ideas and
                      strengthen team relationships.
                    </p>
                  </div>
                  <img src={vision} alt="vision" />
                </div>
              </div>
            </div>
            <div className="col-md-4 d-flex">
              <div className="viscard">
                <div className="vision-content">
                  <div className="vision-title">
                    <p>
                      Our <span style={{ color: "#d2a98e" }}>Mission</span>
                    </p>
                  </div>
                  <div className="vision-desc">
                    <p>
                      Things cannot just be thrown at the wall to see if they
                      stick. You must comprehend your “why.” Everything in your
                      community, from the physical infrastructure to the
                      relationships between people, should be done with the
                      correct objectives in mind.
                    </p>
                  </div>
                  <img src={mission} alt="vision" />
                </div>
              </div>
            </div>

            <div className="col-md-4 d-flex">
              <div className="viscard">
                <div className="vision-content">
                  <div className="vision-title">
                    <p>
                      Our <span style={{ color: "#d2a98e" }}>Values</span>
                    </p>
                  </div>
                  <div className="vision-desc">
                    <p>
                      To enhance lives is our aim while employing socially
                      impacting technology. Those we serve will be at the
                      forefront of whatever platform we create for an the
                      community. We will go where they are and where there is
                      need .
                    </p>
                  </div>
                  <img src={values} alt="vision" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Vision;
